/**
 * SvgFigurePreview — 출력용 SVG 그림 미리보기(계약 BE-20261015 §6-2).
 *
 * 항상 `<img>` 로 그린다(인라인 `<svg>` 삽입 안 함 — 보안·인쇄 규칙 §9). `svgText` 를 주면 data-URI 로 바꿔 그리고,
 * 아니면 `src`(노드의 data-URI)를 쓴다. 둘 다 SVG 면 표시 직전에 KyMath 글꼴을 심는다(figureFont.js, BE-20261019 —
 * 저장본엔 안 들어간다). 크기 규칙은 `ImageComponent.tsx` 의 LazyImage 와 같다 —
 * width/height 가 있으면 그대로(px), 없으면 자연 크기에 `max-width:100%; height:auto`(등축, svgEditor.css);
 * maxWidth(number)를 주면 인라인 max-width(px). 로드에 실패하면 대체 글자를 보인다(그림 자리가 조용히 비지 않게).
 */
import React, { useEffect, useMemo, useState } from 'react';
import { toDataUri } from './figureSvg';
import { embedFigureFont, withFigureFont } from './figureFont';
import './svgEditor.css';

const px = (v) => (typeof v === 'number' ? `${v}px` : v);
const FALLBACK_TEXT = '그림을 불러오지 못했습니다';

export default function SvgFigurePreview({
  src, svgText, width, height, maxWidth, alt = '', className, onClick, style,
}) {
  const resolved = useMemo(() => {
    if (typeof svgText !== 'string') return withFigureFont(src);
    try {
      return toDataUri(embedFigureFont(svgText));
    } catch (e) {   // 홀로 선 서로게이트 등 — 대체 글자로
      return null;
    }
  }, [src, svgText]);
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [resolved]);

  const classes = ['svg-figure-preview', className].filter(Boolean).join(' ');
  if (!resolved || failed) {
    return (
      <span className={`${classes} svg-figure-preview--broken`} style={style} onClick={onClick} role="img" aria-label={alt || FALLBACK_TEXT}>
        {alt || FALLBACK_TEXT}
      </span>
    );
  }
  return (
    <img
      className={classes}
      src={resolved}
      alt={alt}
      style={{ width: px(width), height: px(height), maxWidth: px(maxWidth), ...style }}
      onClick={onClick}
      onError={() => setFailed(true)}
      draggable={false}
    />
  );
}
